module.exports = __webpack_public_path__ + "img/delivery-address-icon.2f429235.png";